import React from 'react';
import Stack from '@mui/material/Stack';

import TabPanel from 'Components/Common/TabPanel';
import EditUserRole from './Role/EditUserRole';
import EditUserBasicInformation from './BasicInformation/EditUserBasicInformation';

interface SettingsContentProps {
    selectedTab: number;
}

const EditUserTabContent: React.FC<SettingsContentProps> = ({
    selectedTab,
}) => {
    return (
        <>
            <TabPanel value={selectedTab} index={0}>
                <Stack spacing={3}>
                    <EditUserBasicInformation />
                </Stack>
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
                <Stack spacing={3}>
                    <EditUserRole />
                </Stack>
            </TabPanel>
        </>
    );
};

export default EditUserTabContent;
